export enum ProjectAppTypes {
  AS = 'AS',
  PF = 'PF',
}

export enum WeldMilestoneType {
  FITUP = 'FITUP',
  INSTALL = 'INSTALL',
}

export enum DeviceType {
  WEB = 'WEB',
}

export enum UNIT_OF_MEASURE {
  HOUR,
  LINEAR_FEET,
  MILESTONE,
  LINEAR_METERS,
}
